import { request, METHOD } from '@/utils/request.js'

    // 查询班级
    export function getClassInfoList(data) {
        return request(
          '/h5Mfitness/teacher/getClassInfoList',
          METHOD.POST,
          data
        )
      }  

       // 根据条件查询学生信息
    export function selectTeacherList(data) {
        return request(
          'h5Mfitness/deviceH5Fitness/selectTeacherList',
          METHOD.POST,
          data
        )
      }  

    export function installTeacher(data) {
        return request(
          'h5Mfitness/deviceH5Fitness/installTeacher',
          METHOD.POST,
          data
        )
      }  
